import { render, staticRenderFns } from "./receive.vue?vue&type=template&id=6928bb62&scoped=true&"
import script from "./receive.js?vue&type=script&lang=js&"
export * from "./receive.js?vue&type=script&lang=js&"
import style0 from "./receive.vue?vue&type=style&index=0&id=6928bb62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6928bb62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data2/workspace/sc-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6928bb62')) {
      api.createRecord('6928bb62', component.options)
    } else {
      api.reload('6928bb62', component.options)
    }
    module.hot.accept("./receive.vue?vue&type=template&id=6928bb62&scoped=true&", function () {
      api.rerender('6928bb62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/seller/scm/receive/receive.vue"
export default component.exports